import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { ImEqualizer2 } from 'react-icons/im'
import { IoTrashSharp } from 'react-icons/io5'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import Layout from '../../components/layouts/Layout'
import DigitalProps from '../events/components/Modal/DigitalProps'
import http, { URL_S3 } from '../../config/BaseUrl'

const DigitalProp = (props) => {

    const { id } = useParams()
    const history = useHistory()
    const dispatch = useDispatch()
    const [emailTemplateErr, setTemplateErr] = useState(false)
    const [digitalPropsItem, setDigitalProps] = useState([])
    const [loading, setLoading] = useState(false);
    
    const digitalPropsEdit = history.location.state.digitalPropsEdit

    const { register, handleSubmit } = useForm()

    useEffect(() => {
        if (digitalPropsEdit) {
            let propsItem = []
            digitalPropsEdit.forEach(item => {
                propsItem.push({ id: item.prop_id, image: item.photo_frame })
            })

            setDigitalProps(propsItem)
        }
    }, [digitalPropsEdit])

    const handelDigitalProp = async (data) => {
        if (digitalPropsItem.length > 0) {
            const submittedData = {
                digital_prop_frame: digitalPropsItem
            }

            setLoading(true)
            await http.post(`/event/props/update/${id}`, submittedData).then((res) => {
                if (res) {
                    setLoading(false)
                    history.push(`/show/event/${id}`, 'Information Updated.')
                }
            })
        }
        else {
            setTemplateErr(true)
        }
    }

    const setDigitalPropsByProps = (data) => {
        setDigitalProps(data)
        setTemplateErr(false)
    }

    const removeProps = (id) => {
        let copyProps = [...digitalPropsItem]
        copyProps.splice(id, 1)
        setDigitalProps(copyProps)

    }

    return (
        <Layout>
            <NewFormWizard />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Digital Prop Settings</p>
                                            <p className="mb-0 text-secondary">Manage your digital props</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit(handelDigitalProp)}>
                    <div className="mt-2 mb-3 row justify-content-center">
                        <div className="col-md-10">
                            <div className="p-4 bg-white border d-flex flex-column radius-10 ">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <ImEqualizer2 size={30} />
                                        <p className="mb-0 ml-2 font-size-16">Prop Library</p>
                                    </div>
                                    <div className="float-right">
                                        <button type="button" className="mr-3 btn btn-outline-primary" data-toggle="modal" data-target="#digital-props-modal">Select</button>

                                        <DigitalProps setData={setDigitalPropsByProps} digitalPropsItem={digitalPropsItem} />
                                    </div>
                                </div>
                                {
                                    emailTemplateErr &&
                                    <p className={`pt-2 mb-0 text-danger font-weight-bold text-right fade ${emailTemplateErr ? 'show' : 'hide'}`}>Choose any library</p>

                                }
                                <div className="prop__area">
                                    <div className="props-list d-flex flex-wrap">
                                        {
                                            digitalPropsItem.length > 0 ?
                                                digitalPropsItem.map((propItem, index) => (
                                                    <div className="prop__item" key={`digital-props-index-${index}`}>
                                                        <img src={`${URL_S3}image/digital_prop/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                        <span className="remove-props" onClick={removeProps.bind(this, index)}>
                                                            <IoTrashSharp />
                                                        </span>
                                                    </div>
                                                ))

                                                :
                                                <div className="prop__no__item">
                                                    <h4>No Props Selected.</h4>
                                                </div>
                                        }

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="submit" className="float-right px-5 btn btn-primary radius-10">
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                    : "Update"
                                }
                            </button>
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default DigitalProp
